export const GET_DESCRIPTION_DEV = {
  en: 'Software Developer oriented on the development of Multimedia Platforms, Scalable Apps, Machine Learning and Artificial Intelligence.',
  es: 'Desarrollador de Software orientado al desarrolllo de Plataformas Multimedia, Aplicaciones Escalables, Machine Learning e Inteligencia Artificial.'
}
export const GET_DESCRIPTION_SOUND = {
  en: "Self-taught Soundman, founder of the Audio Recording and Post-production Studio 'La Ruina Records'.",
  es: "Sonidista autodidacta, fundador del Estudio de Grabación y Post-producción de Audio 'La Ruina Records'."
}
export const GET_DESCRIPTION_DESIGN = {
  en: "Designer oriented to 3D modeling and operator of CNC Routers, CNC Lasers and 3D Printers.",
  es: "Diseñador orientado al modelado 3D y operador de maquinaria CNC Router, CNC Láser e Impresoras 3D."
}